export const RECOMMENDED_WIDTH = 1200
export const RECOMMENDED_HEIGHT = 630
export const DEFAULT_IMAGE_SIZE_LIMIT = 10000
